import { render, staticRenderFns } from "./ProductDownloadFiles.vue?vue&type=template&id=11d5863c&scoped=true&"
import script from "./ProductDownloadFiles.vue?vue&type=script&lang=ts&"
export * from "./ProductDownloadFiles.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDownloadFiles.vue?vue&type=style&index=0&id=11d5863c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d5863c",
  null
  
)

export default component.exports